// @flow
import { PureComponent } from 'react'
import ReactDOM from 'react-dom'
import { isNil } from 'ramda'

type PureComponentProps = {
  children: React$Node,
  domNode?: HTMLElement,
}

export class AppendedComponent extends PureComponent<PureComponentProps> {
  el = document.createElement('div')

  componentDidMount() {
    const { domNode } = this.props

    isNil(domNode) && document.body && document.body.appendChild(this.el)
  }

  componentWillUnmount() {
    const { domNode } = this.props

    isNil(domNode) && document.body && document.body.removeChild(this.el)
  }

  render() {
    return ReactDOM.createPortal(<>{this.props.children}</>, this.props.domNode || this.el)
  }
}
